import Icon from './Icon'
Icon.install = (app) => {
    app.component('Icon', Icon);
}

const req = require.context('../../assets/icons', false, /\.svg$/)
req.keys().map(req)

export default Icon